import React from 'react'

const LoadingScreen = () => {
    return (
        <div>Loading...</div>
    )
}

export default LoadingScreen